import spreadsheetStyles from "./SpreadsheetGrid.module.scss";
import { RemoveSpreadsheetRowButton } from "./RemoveSpreadsheetRowButton";
import { appendSpreadsheetActionsColumn } from "./spreadsheetActionsColumn";
import { ColumnDef } from "./types";

const REMOVE_LINE_COLUMN_WIDTH_PX = 40;

export function withRemoveLineColumn(params: {
    columns: ColumnDef[];
    gridTemplateColumns: string;
}): { columns: ColumnDef[]; gridTemplateColumns: string } {
    const { columns, gridTemplateColumns } = params;
    return {
        columns: appendSpreadsheetActionsColumn(columns, {
            label: "",
            width: REMOVE_LINE_COLUMN_WIDTH_PX,
            isPinnedRight: true,
            cellFn: ({ row, rowIdx, removeRow }) => {
                if (row._isParent === true) {
                    return null;
                }
                return (
                    <RemoveSpreadsheetRowButton
                        ariaLabel="Remove line"
                        className={spreadsheetStyles.showOnRowHover}
                        onClick={() => removeRow(rowIdx)}
                    />
                );
            },
        }),
        gridTemplateColumns: `${gridTemplateColumns} ${REMOVE_LINE_COLUMN_WIDTH_PX}px`,
    };
}
